import request from '@/config/axios'

/**
 * 奖品中心（奖品池 + 库存 + 中奖权重）
 *
 * ★ 权重口径：`winRate` 是**万分比**，不是百分比。
 *   实际概率由后端按同活动全部奖品权重算出（`probability` 字段），
 *   页面另需实时演示「改权重 → 概率变」，因此本地也要能算归一化结果。
 * 2026-09-16 营销中心合并开发 P4
 */

/** 奖品 VO（对应后端 ActivityPrizeRespVO） */
export interface ActivityPrizeVO {
  id?: number
  activityId?: number
  name?: string
  /** 奖品类型：1-优惠券 2-积分 3-红包 4-实物 5-虚拟卡券 6-谢谢参与 */
  prizeType?: number
  /** 关联业务编号（券模板 / 商品等） */
  bizId?: number
  bizSnapshot?: Record<string, any>
  imageUrl?: string
  /** 奖品价值（分） */
  valueAmount?: number
  /** 总库存（0-不限） */
  totalStock?: number
  /** 剩余库存 */
  restStock?: number
  /** 权重（万分比，非百分比） */
  winRate?: number
  /** 实际概率 = winRate / ΣwinRate（后端算出，便于直接展示） */
  probability?: number
  /** 限中类型：0-不限 1-每日 2-活动期间 */
  limitType?: number
  limitCount?: number
  sort?: number
  sorted?: number
  /** 状态：0-开启 1-关闭 */
  status?: number
  createTime?: string
}

/** 获得奖品分页 */
export function getPrizePage(params: any) {
  return request.get({ url: '/promotion/activity-prize/page', params })
}

/** 按活动获得全部奖品（权重归一化与转盘布局都依赖全量，不能用分页） */
export function getPrizeListByActivity(activityId: number) {
  return request.get({ url: '/promotion/activity-prize/list-by-activity', params: { activityId } })
}

/** 获得奖品详情 */
export function getPrize(id: number) {
  return request.get({ url: '/promotion/activity-prize/get', params: { id } })
}

/** 创建奖品 */
export function createPrize(data: ActivityPrizeVO) {
  return request.post({ url: '/promotion/activity-prize/create', data })
}

/** 更新奖品 */
export function updatePrize(data: ActivityPrizeVO) {
  return request.put({ url: '/promotion/activity-prize/update', data })
}

/** 删除奖品 */
export function deletePrize(id: number) {
  return request.delete({ url: '/promotion/activity-prize/delete', params: { id } })
}
